import {DialogContentText} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import {DialogProps} from 'packages/common-types/base-types';

// Redux
import useAppSelector from 'packages/hooks/use-app-selector';
import {
  selectGeneratedRound,
  selectLoadedRound,
} from 'redux/features/round-slice';

import {v4 as uuidv4} from 'uuid';
import GameReportDownload from 'packages/admin/rounds/GameReportDownload';
import {useState, ChangeEvent} from 'react';

type Props = DialogProps & {
  modalityGame: string;
};

const CreateGameReport = (props: Props) => {
  const {modalOpen, toggle, modalityGame} = props;
  const generatedRound = useAppSelector(selectGeneratedRound);
  const loadedRound = useAppSelector(selectLoadedRound);
  console.log(loadedRound);
  const [selectedTable, setSelectedTable] = useState(null);

  const handleChange = (event: ChangeEvent<{value: unknown}>) => {
    setSelectedTable(event.target.value as number);
  };

  const renderTableSelect = () => {
    if (loadedRound) {
      return loadedRound?.map(({tableNumber}) => {
        return (
          <MenuItem key={uuidv4()} value={tableNumber}>
            {tableNumber + 1}
          </MenuItem>
        );
      });
    }

    return generatedRound?.tables?.map(({tableNumber}) => {
      return (
        <MenuItem key={uuidv4()} value={tableNumber}>
          {tableNumber + 1}
        </MenuItem>
      );
    });
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={modalOpen}
      onClose={toggle}
      aria-labelledby="game-report-dialog"
    >
      <DialogTitle id="game-report-dialog">Acta de juego</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Selecciona la mesa a la cual quieres generar el acta de juego
        </DialogContentText>
        <TextField
          fullWidth
          value={selectedTable}
          onChange={handleChange}
          variant="outlined"
          margin="dense"
          label="Selecciona la mesa"
          id="select-table"
          select
        >
          <MenuItem value="" disabled>
            Selecciona una mesa
          </MenuItem>
          {renderTableSelect()}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>

        <GameReportDownload
          selectedTable={selectedTable}
          prevCurrentTable={loadedRound && loadedRound[selectedTable]}
          currentTable={generatedRound?.tables[selectedTable]}
          modalityGame={modalityGame}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CreateGameReport;
